export const environment = {
  production: true,
  envName: 'prod',
  efnolBaseUrl:'https://apiccom.plymouthrock.com/claims/op/efnol/',
  fnolBaseUrl:'https://apiccom.plymouthrock.com/claims/op/fnol/',
  profileBaseUrl:'https://apiccom.plymouthrock.com/claims/op/profile/',
  configBaseUrl: 'https://apiccom.plymouthrock.com/claims/op/dynamicUi/',
  efnol1URL: 'http://efnol.plymouthrock.com/#/',
  KidTimeMin:60,
  IdleTimeMin:30,
  WarningTimeoutMin:2,
  GOOGLE_ANALYTICS_4_ID:	"G-RP7BHWLXT4",
};